import {
    createSelector,
    createStructuredSelector
} from "reselect"
import { formValueSelector } from "redux-form/immutable"

import {
    selectOrganizationPartners,
} from "shared/userdata/userdata-selectors"

const selectTeamUrisArrayFromProps = (_, props) => props.teamUrisArray

export const selectShouldLimitToTeams = createSelector(
    selectTeamUrisArrayFromProps,
    teamUrisArray => teamUrisArray.length
)
export const selectShouldRenderPartnerToggle = createSelector(
    selectOrganizationPartners,
    organizationPartners => organizationPartners && Boolean(organizationPartners.size)
)

const selectIsVisibleToPartners = (state, props) => formValueSelector(props.formName)(state, "is_visible_to_partners")

export const permissionToPartnerFormWrapperConnection = createStructuredSelector({
    isVisible: selectIsVisibleToPartners,
    shouldRenderPartnerToggle: selectShouldRenderPartnerToggle
})
